export default __webpack_public_path__ + "static/media/Sort-A-Z.0010d4de.svg";